<template>
  <div class="top-customers-sales-widget-container">
    <div v-if="loading" class="top-customers-sales-widget-loading">Loading...</div>
    <div v-else-if="error" class="top-customers-sales-widget-error">{{ error }}</div>
    <table v-else class="top-customers-sales-widget-table">
      <thead>
        <tr>
          <th>Customer</th>
          <th class="top-customers-sales-widget-amount-header">Total Sales</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="customers.length === 0">
          <td colspan="2" class="top-customers-sales-widget-empty">No sales data</td>
        </tr>
        <tr v-else v-for="customer in customers" :key="customer.customerId">
          <td>{{ customer.customerName }}</td>
          <td class="top-customers-sales-widget-amount-cell">{{ formatCurrency(customer.amount) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import './styles/TopCustomersBySalesWidget.css';
import SalesReportService from '@/services/salesReport.service';
import logger from '@/utils/logger';

export default {
  name: 'TopCustomersBySalesWidget',
  props: {
    companyId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      customers: [],
      loading: true,
      error: null
    };
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.error = null;
      try {
        const result = await SalesReportService.getSalesByCustomerSummary(this.companyId, {
          reportBasis: 'accrual'
        });
        
        this.customers = (result.data || [])
          .sort((a, b) => b.amount - a.amount)
          .slice(0, 10); // Top 10
      } catch (error) {
        logger.error('Error fetching top customers:', error);
        this.error = 'Failed to load data';
      } finally {
        this.loading = false;
      }
    },
    formatCurrency(amount) {
      if (amount === null || amount === undefined || isNaN(amount)) return '$0.00';
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(amount);
    }
  }
};
</script>

